import React from 'react';

import { Text } from '@zapier/design-system';

import { Body, Footer, Header, Wrapper } from '../Layout';

type Props = {
  onClose: () => void;
};

const Settings = (props: Props) => {
  return (
    <Wrapper>
      <Header onClose={props.onClose} title="Settings" />
      <Body>
        <Text>
          This is a placeholder visible to staff only for now. We’ll flesh it
          out. If you have good use cases here, please reach out to
          #team-dev-platform. We’ll be happy to collaborate with you.
        </Text>
      </Body>
      <Footer />
    </Wrapper>
  );
};

export default Settings;
